<ng-container *ngIf="baseState$ | async as state">
  <div *ngIf="state.data && state.isVisible"
       [data-preview-id]="state.isChild ? '' : state.data.previewId"
       [ngClass]="state.data.padding + ' ' + state.data.bgColor"
       class="container container--button-centered"
       data-cy="centralized-button-container"
  >
    <div class="row text-center">
      <span class="col-12">
        <mb-link [linkData]="state.data.link"
                 [styleClass]="['centralized-button', 'btn', 'btn-primary']"
                 dataCy="centralized-button-link"
        ></mb-link>
      </span>
    </div>
  </div>
</ng-container>
